webpackJsonp([2],{

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRouters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dynamicRouters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login_index__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Homepage_Home__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Homepage_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Homepage_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Permission__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Permission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Permission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ErrorPages_NoPermission__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ErrorPages_NoPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_ErrorPages_NoPermission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ErrorPages_NotFound__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ErrorPages_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_ErrorPages_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_layout_Frame__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Components_Markdown__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Components_Markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Components_Markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Components_Richtext__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Components_Richtext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Components_Richtext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Components_Draggablelist__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Components_Draggablelist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Components_Draggablelist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Components_Linechart__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Components_Linechart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Components_Linechart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Components_Barchart__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Components_Barchart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Components_Barchart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Components_Radarchart__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Components_Radarchart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Components_Radarchart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Tabs__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Tables_Inlineedit__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Tables_Inlineedit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_Tables_Inlineedit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Tables_Dynamic__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Tables_Dynamic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_Tables_Dynamic__);









// import components




// import charts




// import tabs


// import tables



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var staticRouters = [{
  path: '/',
  noDropdown: true,
  redirect: '/index',
  component: __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default.a,
  icon: 'fa fa-home fa-lg',
  children: [{ path: 'index', component: __WEBPACK_IMPORTED_MODULE_3__views_Homepage_Home___default.a, name: 'Home' }]
}, {
  path: '/login',
  name: 'Login',
  hidden: true,
  noDropdown: true,
  component: __WEBPACK_IMPORTED_MODULE_2__views_login_index___default.a
}, {
  path: '/404',
  name: '404',
  hidden: true,
  noDropdown: true,
  component: __WEBPACK_IMPORTED_MODULE_6__views_ErrorPages_NotFound___default.a
}, {
  path: '/401',
  name: '401',
  hidden: true,
  noDropdown: true,
  component: __WEBPACK_IMPORTED_MODULE_5__views_ErrorPages_NoPermission___default.a
}];

var dynamicRouters = [{
  path: '/permission',
  component: __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default.a,
  redirect: '/permission/index',
  name: 'Permission',
  icon: 'fa fa-unlock fa-lg',
  meta: { role: ['admin'] },
  noDropdown: false,
  children: [{ path: 'index', component: __WEBPACK_IMPORTED_MODULE_4__views_Permission___default.a, name: 'Permission Test', meta: { role: ['admin'] } }]
}, {
  path: '/components',
  component: __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default.a,
  name: 'Components',
  icon: 'fa fa-cogs fa-lg',
  meta: { role: ['admin'] },
  children: [{ path: 'markdown', component: __WEBPACK_IMPORTED_MODULE_8__views_Components_Markdown___default.a, name: 'Markdown Editor' }, { path: 'richtext', component: __WEBPACK_IMPORTED_MODULE_9__views_Components_Richtext___default.a, name: 'Richtext Editor' }, { path: 'draggable', component: __WEBPACK_IMPORTED_MODULE_10__views_Components_Draggablelist___default.a, name: 'Draggable List' }]
}, {
  path: '/tables',
  component: __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default.a,
  name: 'Tables',
  icon: 'fa fa-table fa-lg',
  meta: { role: ['admin'] },
  children: [{ path: 'inlineedit', component: __WEBPACK_IMPORTED_MODULE_15__views_Tables_Inlineedit___default.a, name: 'Inline edit' }, { path: 'dynamic', component: __WEBPACK_IMPORTED_MODULE_16__views_Tables_Dynamic___default.a, name: 'Dynamic' }]
}, {
  path: '/charts',
  component: __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default.a,
  name: 'Charts',
  icon: 'fa fa-bar-chart fa-lg',
  meta: { role: ['admin'] },
  children: [{ path: 'linechart', component: __WEBPACK_IMPORTED_MODULE_11__views_Components_Linechart___default.a, name: 'Line chart' }, { path: 'barchart', component: __WEBPACK_IMPORTED_MODULE_12__views_Components_Barchart___default.a, name: 'Bar chart' }, { path: 'radarchart', component: __WEBPACK_IMPORTED_MODULE_13__views_Components_Radarchart___default.a, name: 'Radar chart' }]
}, {
  path: '/tabs',
  component: __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default.a,
  icon: 'fa fa-window-restore fa-lg',
  redirect: 'index',
  noDropdown: true,
  meta: { role: ['admin'] },
  children: [{ path: 'index', component: __WEBPACK_IMPORTED_MODULE_14__views_Tabs___default.a, name: 'Tabs' }]
}, {
  path: '/errorpages',
  component: __WEBPACK_IMPORTED_MODULE_7__views_layout_Frame___default.a,
  name: 'Error Pages',
  icon: 'fa fa-exclamation-triangle fa-lg',
  meta: { role: ['admin'] },
  children: [{ path: '401', component: __WEBPACK_IMPORTED_MODULE_5__views_ErrorPages_NoPermission___default.a, name: 'NoPermission 401' }, { path: '404', component: __WEBPACK_IMPORTED_MODULE_6__views_ErrorPages_NotFound___default.a, name: 'NotFound 404' }]
}, { path: '*', redirect: '/404', hidden: true }];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: staticRouters
}));

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_permission__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(317);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_3__modules_permission__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(757),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(771),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e926e170",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(759),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-533d7b54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(749),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_layout_Sidebar__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_layout_Navbar__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_layout_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_layout_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(72);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['token'])),
  components: {
    'Sidebar': __WEBPACK_IMPORTED_MODULE_1__views_layout_Sidebar___default.a,
    'Navbar': __WEBPACK_IMPORTED_MODULE_2__views_layout_Navbar___default.a
  }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_chart__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['id'],
    name: 'Barchart',
    components: {
        'ESchart': __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default.a
    },
    created: function created() {
        var _this = this;

        setTimeout(function () {
            _this.initOption();
        }, 1000);
    },
    data: function data() {
        return {
            option: null
        };
    },

    methods: {
        initOption: function initOption() {
            this.option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['Immediate visit', 'Email marketing', 'Phone marketing', 'Video advertise', 'Search engine']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value'
                },
                yAxis: {
                    type: 'category',
                    data: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
                },
                series: [{
                    name: 'Immediate visit',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [320, 302, 301, 334, 390, 330, 320]
                }, {
                    name: 'Email marketing',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: 'Phone marketing',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: 'Video advertise',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [150, 212, 201, 154, 190, 330, 410]
                }, {
                    name: 'Search engine',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [820, 832, 901, 934, 1290, 1330, 1320]
                }]
            };
        }
    }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_draggablelist__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_draggablelist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_draggablelist__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Draglist',
  components: {
    'Draggablelist': __WEBPACK_IMPORTED_MODULE_0__widgets_draggablelist___default.a
  },
  created: function created() {
    this.cloneLists();
  },
  data: function data() {
    return {
      list1Copy: [],
      list2Copy: [],
      list1: [{
        name: "John"
      }, {
        name: "Joao"
      }, {
        name: "Jean"
      }],
      list2: [{
        name: "Juan"
      }, {
        name: "Edgard"
      }, {
        name: "Johnson"
      }, {
        name: "Juan"
      }, {
        name: "Edgard"
      }, {
        name: "Johnson"
      }, {
        name: "Juan"
      }, {
        name: "Edgard"
      }, {
        name: "Johnson"
      }]
    };
  },

  methods: {
    cloneLists: function cloneLists() {
      this.list1Copy = this.list1.slice();
      this.list2Copy = this.list2.slice();
    },
    updateChange: function updateChange() {
      // send change request to backend
      this.cloneLists();
    },
    reset: function reset() {
      this.list1 = this.list1Copy.slice();
      this.list2 = this.list2Copy.slice();
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['id'],
    name: 'Linechart',
    components: {
        'ESchart': __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default.a
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.initOption();
        }, 1000);
    },
    data: function data() {
        return {
            option: null
        };
    },

    methods: {
        initOption: function initOption() {
            var category = [];
            var dottedBase = +new Date();
            var lineData = [];
            var barData = [];

            for (var i = 0; i < 20; i++) {
                var date = new Date(dottedBase += 1000 * 3600 * 24);
                category.push([date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'));
                var b = Math.random() * 200;
                var d = Math.random() * 200;
                barData.push(b);
                lineData.push(d + b);
            }

            // option
            this.option = {
                backgroundColor: '#0f375f',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                            backgroundColor: '#333'
                        }
                    }
                },
                legend: {
                    data: ['line', 'bar'],
                    textStyle: {
                        color: '#ccc'
                    }
                },
                xAxis: {
                    data: category,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    }
                },
                yAxis: {
                    splitLine: { show: false },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    }
                },
                series: [{
                    name: 'line',
                    type: 'line',
                    smooth: true,
                    showAllSymbol: true,
                    symbol: 'emptyCircle',
                    symbolSize: 15,
                    data: lineData
                }, {
                    name: 'bar',
                    type: 'bar',
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            barBorderRadius: 5,
                            color: new __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#14c8d4' }, { offset: 1, color: '#43eec6' }])
                        }
                    },
                    data: barData
                }, {
                    name: 'line',
                    type: 'bar',
                    barGap: '-100%',
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            color: new __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(20,200,212,0.5)' }, { offset: 0.2, color: 'rgba(20,200,212,0.2)' }, { offset: 1, color: 'rgba(20,200,212,0)' }])
                        }
                    },
                    z: -12,
                    data: lineData
                }, {
                    name: 'dotted',
                    type: 'pictorialBar',
                    symbol: 'rect',
                    itemStyle: {
                        normal: {
                            color: '#0f375f'
                        }
                    },
                    symbolRepeat: true,
                    symbolSize: [12, 4],
                    symbolMargin: 1,
                    z: -10,
                    data: lineData
                }]
            };
        }
    }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_markdown__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_markdown__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Markdown',
  components: {
    'MarkdownEditor': __WEBPACK_IMPORTED_MODULE_0__widgets_markdown___default.a
  },
  data: function data() {
    return {
      content: '',
      html: ''
    };
  },

  methods: {
    markdown2Html: function markdown2Html() {
      var _this = this;

      __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 810)).then(function (showdown) {
        var converter = new showdown.Converter();
        _this.html = converter.makeHtml(_this.content);
      });
    }
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_chart__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['id'],
    name: 'Radarchart',
    components: {
        'ESchart': __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default.a
    },
    created: function created() {
        var _this = this;

        setTimeout(function () {
            _this.initOption();
        }, 1000);
    },
    data: function data() {
        return {
            option: null
        };
    },

    methods: {
        initOption: function initOption() {
            this.option = {
                title: {
                    text: 'Radar chart'
                },
                tooltip: {},
                legend: {
                    top: 20,
                    itemWidth: 12,
                    itemHeight: 12,
                    data: ['Allocated Budget', 'Actual Spending'],
                    textStyle: {
                        color: '#fff'
                    }
                },
                radar: {
                    radius: '60%',
                    splitNumber: 8,
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                            opacity: .2
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#fff',
                            opacity: .2
                        }
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(127,95,132,.3)',
                            opacity: 1,
                            shadowBlur: 45,
                            shadowColor: 'rgba(0,0,0,.5)',
                            shadowOffsetX: 0,
                            shadowOffsetY: 15
                        }
                    },
                    indicator: [{
                        name: 'Sales',
                        max: 6000
                    }, {
                        name: 'Administration',
                        max: 16000
                    }, {
                        name: 'Information Techology',
                        max: 30000
                    }, {
                        name: 'Customer Support',
                        max: 35000
                    }, {
                        name: 'Development',
                        max: 50000
                    }, {
                        name: 'Marketing',
                        max: 25000
                    }]
                },
                series: [{
                    name: 'Budget vs spending',
                    type: 'radar',
                    symbolSize: 0,
                    areaStyle: {
                        normal: {
                            shadowBlur: 13,
                            shadowColor: 'rgba(0,0,0,.2)',
                            shadowOffsetX: 0,
                            shadowOffsetY: 10,
                            opacity: 1
                        }
                    },
                    data: [{
                        value: [5000, 7000, 12000, 11000, 15000, 14000],
                        name: 'Allocated Budget'
                    }, {
                        value: [2500, 12000, 8000, 8500, 12000, 12000],
                        name: 'Actual Spending'
                    }]
                }],
                color: ['#ef4b4c', '#b1eadb'],
                backgroundColor: {
                    type: 'radial',
                    x: 0.4,
                    y: 0.4,
                    r: 0.35,
                    colorStops: [{
                        offset: 0,
                        color: '#895355' // 0% 
                    }, {
                        offset: .4,
                        color: '#593640' // 100% 
                    }, {
                        offset: 1,
                        color: '#39273d' // 100% 
                    }],
                    globalCoord: false //  false
                }
            };
        }
    }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_richtext__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_richtext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_richtext__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Richtext',
  components: {
    'RichtextEditor': __WEBPACK_IMPORTED_MODULE_0__widgets_richtext___default.a
  },
  data: function data() {
    return {
      content: '',
      html: ''
    };
  },

  methods: {}
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NoPermission'
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NoPermission'
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Linechart__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Linechart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_Linechart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    components: {
        'ESchart': __WEBPACK_IMPORTED_MODULE_0__widgets_chart___default.a,
        'Linechart': __WEBPACK_IMPORTED_MODULE_1__Components_Linechart___default.a
    },
    created: function created() {
        var _this = this;

        var id = setTimeout(function () {
            _this.init();
            clearTimeout(id);
        }, 1000);
    },
    data: function data() {
        return {
            option1: null,
            option2: null
        };
    },

    methods: {
        getOption1: function getOption1() {
            return {
                title: {
                    text: 'Radar chart'
                },
                tooltip: {},
                legend: {
                    top: 20,
                    itemWidth: 12,
                    itemHeight: 12,
                    data: ['Allocated Budget', 'Actual Spending'],
                    textStyle: {
                        color: '#fff'
                    }
                },
                radar: {
                    radius: '60%',
                    splitNumber: 8,
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                            opacity: .2
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#fff',
                            opacity: .2
                        }
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(127,95,132,.3)',
                            opacity: 1,
                            shadowBlur: 45,
                            shadowColor: 'rgba(0,0,0,.5)',
                            shadowOffsetX: 0,
                            shadowOffsetY: 15
                        }
                    },
                    indicator: [{
                        name: 'Sales',
                        max: 6000
                    }, {
                        name: 'Administration',
                        max: 16000
                    }, {
                        name: 'Information Techology',
                        max: 30000
                    }, {
                        name: 'Customer Support',
                        max: 35000
                    }, {
                        name: 'Development',
                        max: 50000
                    }, {
                        name: 'Marketing',
                        max: 25000
                    }]
                },
                series: [{
                    name: 'Budget vs spending',
                    type: 'radar',
                    symbolSize: 0,
                    areaStyle: {
                        normal: {
                            shadowBlur: 13,
                            shadowColor: 'rgba(0,0,0,.2)',
                            shadowOffsetX: 0,
                            shadowOffsetY: 10,
                            opacity: 1
                        }
                    },
                    data: [{
                        value: [5000, 7000, 12000, 11000, 15000, 14000],
                        name: 'Allocated Budget'
                    }, {
                        value: [2500, 12000, 8000, 8500, 12000, 12000],
                        name: 'Actual Spending'
                    }]
                }],
                color: ['#ef4b4c', '#b1eadb'],
                backgroundColor: {
                    type: 'radial',
                    x: 0.4,
                    y: 0.4,
                    r: 0.35,
                    colorStops: [{
                        offset: 0,
                        color: '#895355' // 0% 
                    }, {
                        offset: .4,
                        color: '#593640' // 100% 
                    }, {
                        offset: 1,
                        color: '#39273d' // 100% 
                    }],
                    globalCoord: false //  false
                }
            };
        },
        getOption2: function getOption2() {
            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['Immediate visit', 'Email marketing', 'Phone marketing', 'Video advertise', 'Search engine']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value'
                },
                yAxis: {
                    type: 'category',
                    data: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
                },
                series: [{
                    name: 'Immediate visit',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [320, 302, 301, 334, 390, 330, 320]
                }, {
                    name: 'Email marketing',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: 'Phone marketing',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: 'Video advertise',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [150, 212, 201, 154, 190, 330, 410]
                }, {
                    name: 'Search engine',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    data: [820, 832, 901, 934, 1290, 1330, 1320]
                }]
            };
        },
        init: function init() {
            // Generate data
            this.option1 = this.getOption1();
            this.option2 = this.getOption2();
        }
    },
    computed: {
        key: function key() {
            return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
        }
    }
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home'
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialogFormVisible: false,
      company: {
        name: '',
        state: '',
        city: '',
        address: '',
        post: ''
      },
      tableData3: [{
        name: 'Company',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        post: 3163
      }, {
        name: 'Company',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        post: 3163
      }, {
        name: 'Company',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        post: 3163
      }, {
        name: 'Company',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        post: 3163
      }, {
        name: 'Company',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        post: 3163
      }, {
        name: 'Company',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        post: 3163
      }, {
        name: 'Company',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        post: 3163
      }]
    };
  },

  methods: {
    clearPreviousInput: function clearPreviousInput() {
      for (var key in this.company) {
        this.company[key] = '';
      }
    },
    hideCreateDialog: function hideCreateDialog() {
      this.clearPreviousInput();
      this.dialogFormVisible = false;
    },
    handelCreateCancel: function handelCreateCancel() {
      this.hideCreateDialog();
      this.$message({
        type: 'info',
        message: 'Canceled'
      });
    },
    handelCreateConfrim: function handelCreateConfrim() {
      var _this = this;

      this.createCompany().then(function (response) {
        _this.hideCreateDialog();
        _this.$message({
          type: 'success',
          message: 'Company created'
        });
      }).catch(function (error) {
        _this.$message({
          type: 'success',
          message: error.message
        });
      });
    },
    createCompany: function createCompany() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.tableData3.splice(0, 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* deepClone */])(_this2.company));
        resolve();
      });
    }
  }
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      editingItemCopies: [],
      tableData: [{

        date: '2016-05-02',
        id: '1',
        name: 'Test',
        address: '19 Jersey Parade',
        editing: false
      }, {
        date: '2016-05-04',
        id: '2',
        name: 'Test',
        address: '19 Jersey Parade',
        editing: false
      }, {
        date: '2016-05-01',
        id: '3',
        name: 'Test',
        address: '19 Jersey Parade',
        editing: false
      }, {
        date: '2016-05-03',
        id: '4',
        name: 'Test',
        address: '19 Jersey Parade',
        editing: false
      }],
      pickerOptions1: {
        shortcuts: [{
          text: 'Today',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Yesterday',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'One week ago',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }
    };
  },

  methods: {
    handleEdit: function handleEdit(index, row) {
      this.tableData[index].editing = true;
      this.editingItemCopies[index] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* deepClone */])(this.tableData[index]);
    },
    handleSave: function handleSave(index, row) {
      this.editingItemCopies.slice(index, 1);
      if (typeof this.tableData[index].date != 'string') {
        var date = this.tableData[index].date;
        var month = date.getMonth() + 1;
        var strMonth = month > 9 ? month + '' : '0' + month;
        var day = date.getDate();
        var strDay = day > 9 ? day + '' : '0' + day;
        var strDate = date.getFullYear() + "-" + strMonth + "-" + strDay;
        this.tableData[index].date = strDate;
      }
      this.tableData[index].editing = false;
      this.$message({
        type: 'success',
        message: 'Success!'
      });
    },
    handleCancelEdit: function handleCancelEdit(index, row) {
      this.tableData.splice(index, 1, this.editingItemCopies[index]);
      this.editingItemCopies[index] = null;
      this.tableData[index].editing = false;
      this.$message({
        type: 'info',
        message: 'Cancel'
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      this.$confirm('Are you sure delete this row', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this.tableData.splice(index, 1);
        _this.$message({
          type: 'success',
          message: 'Success!'
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: 'Cancel'
        });
      });
    }
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log('submit!');
    }
  }
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tablecontent__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tablecontent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tablecontent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formcontent__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formcontent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__formcontent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tabs',
  components: {
    'Tablecontent': __WEBPACK_IMPORTED_MODULE_0__tablecontent___default.a,
    'Formcontent': __WEBPACK_IMPORTED_MODULE_1__formcontent___default.a
  },
  data: function data() {
    return {
      activeName: 'first'
    };
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tabs',
  data: function data() {
    return {
      tableData3: [{
        date: '2016-05-03',
        name: 'Hello',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        zip: 3163
      }, {
        date: '2016-05-02',
        name: 'Hello',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        zip: 3163
      }, {
        date: '2016-05-04',
        name: 'Hello',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        zip: 3163
      }, {
        date: '2016-05-01',
        name: 'Hello',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        zip: 3163
      }, {
        date: '2016-05-08',
        name: 'Hello',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        zip: 3163
      }, {
        date: '2016-05-06',
        name: 'Hello',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        zip: 3163
      }, {
        date: '2016-05-07',
        name: 'Hello',
        state: 'VIC',
        city: 'Carnegie',
        address: '19 Jersey Parade',
        zip: 3163
      }]
    };
  }
});

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navbar__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(72);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['token'])),
  components: {
    'Sidebar': __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a,
    'Navbar': __WEBPACK_IMPORTED_MODULE_2__Navbar___default.a
  }
});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(72);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		handleSelect: function handleSelect(key, keypath) {

			if (key === '1-1') {
				this.$store.dispatch('LogOut').then(function () {
					location.reload(); // 
				}).catch(function (error) {});
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['name', 'avatar']))
});

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SidebarItem__);

//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		'SidebarItem': __WEBPACK_IMPORTED_MODULE_2__SidebarItem___default.a
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['routes']))
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SidebarItem',
	props: {
		routes: {
			type: Array
		}
	}
});

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    var valudateEmail = function valudateEmail(rule, value, callback) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        callback(new Error('Please enter a valid email address'));
      }
      callback();
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error('Password length cannot be less than 6'));
      }
      callback();
    };
    return {
      loading: false,
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [{ required: true, trigger: 'blur', validator: valudateEmail }],
        password: [{ required: true, trigger: 'blur', validator: validatePass }]
      }
    };
  },

  methods: {
    handleLogin: function handleLogin() {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          _this.$store.dispatch('LoginByEmail', _this.loginForm).then(function () {
            _this.loading = false;
            _this.$router.push({ path: '/' });
          }).catch(function (error) {
            _this.loading = false;
            _this.$message.error(error.message);
          });
        } else {
          console.log('error submit!');
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ESLineChart',
	props: {
		id: {
			type: String,
			default: 'es-chart'
		},
		width: {
			type: String,
			default: '100%'
		},
		height: {
			type: String,
			default: '90vh'
		},
		option: {
			required: true
		}
	},
	watch: {
		'option': 'redraw' // it seems that it doesn't work
	},
	mounted: function mounted() {
		this.initChart();
	},
	data: function data() {
		return {
			chart: null
		};
	},
	beforeDestroy: function beforeDestroy() {
		if (!this.chart) {
			return;
		}
		this.chart.dispose();
		this.chart = null;
		console.log('before destory called');
	},

	methods: {
		initChart: function initChart() {
			console.log('initcalled');
			this.chart = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById(this.id));
			// Generate data
			this.chart.setOption(this.option);
		},
		redraw: function redraw() {
			if (this.chart) {
				this.chart.setOption(this.option);
			}
		}
	}
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'draggablelist',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
  },
  props: {
    displayedProperty: {
      type: String,
      default: '',
      required: true
    },
    list1Title: {
      type: String,
      default: ''
    },
    list2Title: {
      type: String,
      deault: ''
    },
    initList1: {
      type: Array,
      default: []
    },
    initList2: {
      type: Array,
      default: []
    }
  },
  watch: {
    initList1: function initList1(val) {
      this.list1 = this.initList1;
    },
    initList2: function initList2(val) {
      this.list2 = this.initList2;
    },
    isDragging: function isDragging(newValue) {
      var _this = this;

      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(function () {
        _this.delayedDragging = false;
      });
    }
  },
  data: function data() {
    return {
      editable: true,
      isDragging: false,
      delayedDragging: false,
      list1: this.initList1,
      list2: this.initList2
    };
  },

  methods: {
    orderList: function orderList() {
      this.list = this.list.sort(function (one, two) {
        return one.order - two.order;
      });
    },
    updateList: function updateList() {
      this.$emit('update:initList1', this.list1.slice());
      this.$emit('update:initList2', this.list2.slice());
    }
  },
  computed: {
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      };
    }
  }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simplemde_dist_simplemde_min_css__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simplemde_dist_simplemde_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_simplemde_dist_simplemde_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simplemde__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simplemde___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simplemde__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MarkdownEditor',
  props: {
    value: String,
    id: {
      type: String,
      default: 'markdown-editor'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    spellChecker: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 50
    },
    zIndex: {
      type: Number,
      default: 10
    },
    toolbar: {
      type: Array
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.simplemde = new __WEBPACK_IMPORTED_MODULE_1_simplemde___default.a({
      element: document.getElementById(this.id),
      autofocus: this.autofocus,
      toolbar: this.toolbar,
      spellChecker: this.spellChecker,
      blockStyles: {
        bold: "__",
        italic: "_"
      },
      insertTexts: {
        horizontalRule: ["", "\n\n-----\n\n"],
        image: ["![](http://", ")"],
        link: ["[", "](http://)"],
        table: ["", "\n\n| Column 1 | Column 2 | Column 3 |\n| -------- | -------- | -------- |\n| Text     | Text      | Text     |\n\n"]
      },
      placeholder: this.placeholder
    });
    if (this.value) {
      this.simplemde.value(this.value);
    }
    this.simplemde.codemirror.on('change', function () {
      _this.$emit('input', _this.simplemde.value());
    });
  },
  data: function data() {
    return {
      simplemde: null
    };
  },

  watch: {
    value: function value(val) {
      if (val === this.simplemde.value()) {
        return;
      }
      this.simplemde.value(val);
    }
  },
  destroyed: function destroyed() {
    this.simplemde = null;
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinymce_tinymce__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinymce_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tinymce_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinymce_themes_modern_theme__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinymce_themes_modern_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tinymce_themes_modern_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinymce_skins_lightgray_skin_min_css__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinymce_skins_lightgray_skin_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tinymce_skins_lightgray_skin_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_skins_lightgray_content_min_css__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_skins_lightgray_content_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_tinymce_skins_lightgray_content_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_paste__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_paste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_paste__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_link__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_table__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_advlist__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_advlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_advlist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_autolink__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_autolink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_autolink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_lists__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_image__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_charmap__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_charmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_charmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_print__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_preview__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_anchor__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_fullscreen__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_pagebreak__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_pagebreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_pagebreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_searchreplace__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_searchreplace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_searchreplace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_wordcount__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_wordcount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_wordcount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_tinymce_plugins_visualblocks__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_tinymce_plugins_visualblocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_tinymce_plugins_visualblocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_tinymce_plugins_visualchars__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_tinymce_plugins_visualchars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_tinymce_plugins_visualchars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_tinymce_plugins_insertdatetime__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_tinymce_plugins_insertdatetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_tinymce_plugins_insertdatetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_tinymce_plugins_media__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_tinymce_plugins_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_tinymce_plugins_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_tinymce_plugins_save__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_tinymce_plugins_save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_tinymce_plugins_save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_tinymce_plugins_hr__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_tinymce_plugins_hr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_tinymce_plugins_hr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_tinymce_plugins_code__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_tinymce_plugins_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_tinymce_plugins_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_tinymce_plugins_contextmenu__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_tinymce_plugins_contextmenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_tinymce_plugins_contextmenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_tinymce_plugins_directionality__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_tinymce_plugins_directionality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_tinymce_plugins_directionality__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_tinymce_plugins_template__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_tinymce_plugins_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_tinymce_plugins_template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_tinymce_plugins_textcolor__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_tinymce_plugins_textcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_tinymce_plugins_textcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_tinymce_plugins_textpattern__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_tinymce_plugins_textpattern___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_tinymce_plugins_textpattern__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_tinymce_plugins_imagetools__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_tinymce_plugins_imagetools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_tinymce_plugins_imagetools__);

//
//
//
//
//
//


// Import TinyMCE

// A theme is also required

// require.context(
//   'file-loader?name=[path][name].[ext]&context=node_modules/tinymce!tinymce/skins', 
//   true, 
//   /.*/
// );


// Any plugins you want to use has to be imported






























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MarkdownEditor',
  props: {
    value: String,
    id: {
      type: String,
      default: 'richtext-editor'
    },
    toolbar: {
      type: Array,
      required: false,
      default: function _default() {
        return ['removeformat undo redo |  bullist numlist | outdent indent | forecolor | fullscreen code', 'bold italic blockquote | h2 p  media link | alignleft aligncenter alignright'];
      }
    },
    menubar: menubar
  },
  mounted: function mounted() {
    var _tinymce$init;

    console.log('mounted called');
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_1_tinymce_tinymce___default.a.init((_tinymce$init = {
      selector: '#' + this.id
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'selector', 'textarea'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'height', 500), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'theme', 'modern'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'plugins', ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media save table contextmenu directionality', 'template paste textcolor  textpattern imagetools']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'toolbar1', 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'toolbar2', 'print preview media | forecolor backcolor emoticons'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'image_advtab', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'templates', [{ title: 'Test template 1', content: 'Test 1' }, { title: 'Test template 2', content: 'Test 2' }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_tinymce$init, 'setup', function setup(editor) {
      editor.on('NodeChange Change KeyUp', function () {
        //   _this.value = e.target.getContent();
        _this.$emit('input', editor.getContent({ format: 'raw' }));
      });
    }), _tinymce$init));
  },
  data: function data() {
    return {
      simplemde: null
    };
  },

  // watch:{
  // 	value(val) {
  // 		if( val === this.simplemde.value()){
  // 			return;
  // 		}
  // 		this.simplemde.value(val);
  // 	}
  // },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1_tinymce_tinymce___default.a.get(this.id).destroy();
  }
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loginByEmailAdmin;
/* harmony export (immutable) */ __webpack_exports__["b"] = loginByEmailEditor;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUserInfoAdmin;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUserInfoEditor;
/* harmony export (immutable) */ __webpack_exports__["e"] = logOut;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_axiosIns__ = __webpack_require__(320);



function loginByEmailAdmin(email, password) {
	var data = {
		email: email,
		password: password
	};
	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		resolve();
	});
	// return axiosIns({
	// 	// for error testing, uncomment below line
	// 	//url:'http://www.mocky.io/v2/596f198f0f000095026b73b2',
	// 	// and comment below line
	// 	url:'https://www.mocky.io/v2/5971fce8120000eb04bb7495',
	// 	method:'post',
	// 	data
	// });
}

function loginByEmailEditor(email, password) {
	var data = {
		email: email,
		password: password
		// return axiosIns({
		// 	// for error testing, uncomment below line
		// 	//url:'http://www.mocky.io/v2/596f198f0f000095026b73b2',
		// 	// and comment below line
		// 	url:'https://www.mocky.io/v2/5971fd2e120000d404bb7498',
		// 	method:'post',
		// 	data
		// });
	};return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		resolve();
	});
}

function getUserInfoAdmin(token) {
	var data = {
		token: token
		// return axiosIns({
		// 	url:'https://www.mocky.io/v2/5971f9ed120000ed04bb7480',
		// 	method:'post',
		// 	data
		// });
	};return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		resolve();
	});
}

function getUserInfoEditor(token) {
	var data = {
		token: token
		// return axiosIns({
		// 	url:'https://www.mocky.io/v2/5971fefb120000f704bb74aa',
		// 	method:'post',
		// 	data
		// });
	};return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		resolve();
	});
}

function logOut() {
	// return axiosIns({
	// 	url:'https://www.mocky.io/v2/5971fefb120000f704bb74aa',
	// 	method:'post',
	// });
	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		resolve();
	});
}

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nprogress_nprogress_css__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(141);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



 // Progress
 // Progress css


// import Element UI


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

var whiteList = ['/login'];

function hasPermission(roles, allowedRoles) {
	console.log(roles);
	console.log(allowedRoles);

	if (roles.indexOf('admin') >= 0) {
		return true;
	}

	if (!allowedRoles) {
		return true;
	}

	if (roles.some(function (role) {
		return allowedRoles.indexOf(role) >= 0;
	})) {
		return true;
	}

	return false;
}

// config router
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
	__WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.start();
	if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.token) {
		// already logedin then redirect to home page
		if (to.path === '/login') {
			next({ path: '/' });
		} else {
			// user info hasn't been fetched
			if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.roles.length === 0) {
				// get user info
				__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('GetInfo').then(function (response) {
					// based on user info, generate dynamic routers
					__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('GenerateDynamicRoutes', response).then(function (response) {
						__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].addRoutes(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.dynamicRouters);
						next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to));
					}).cathc(function (error) {});
				}).catch(function (error) {});
			} else {
				console.log('else called');
				if (hasPermission(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.roles, to.meta.role)) {
					console.log('permission check passed');
					next();
				} else {
					next({ path: '/401', query: { noGoBack: true } });
				}
			}
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next();
		} else {
			next({ path: '/login' });
		}
	}
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function () {
	__WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.done();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  status: function status(state) {
    return state.user.status;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  setting: function setting(state) {
    return state.user.setting;
  },
  dynamicRouters: function dynamicRouters(state) {
    return state.permission.dynamicRouters;
  },
  routes: function routes(state) {
    return state.permission.allRouters;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dynamicRouterFilter__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(98);





var permission = {
	state: {
		// for debug
		allRouters: __WEBPACK_IMPORTED_MODULE_1__router__["b" /* staticRouters */],
		dynamicRouters: ''
	},
	mutations: {
		GENERATE_DYNAMIC_ROUTERS: function GENERATE_DYNAMIC_ROUTERS(state, allowedRouters) {
			state.dynamicRouters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["a" /* deepClone */])(allowedRouters);
			state.allRouters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["a" /* deepClone */])(__WEBPACK_IMPORTED_MODULE_1__router__["b" /* staticRouters */].concat(allowedRouters));
		}
	},
	actions: {
		GenerateDynamicRoutes: function GenerateDynamicRoutes(_ref, data) {
			var commit = _ref.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var roles = data.roles;
				var allowedRouters = [];
				if (roles.indexOf('admin') >= 0) {
					allowedRouters = __WEBPACK_IMPORTED_MODULE_1__router__["c" /* dynamicRouters */];
					// console.log(allowedRouters);
				} else {
					allowedRouters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dynamicRouterFilter__["a" /* filterDynamicRouters */])(__WEBPACK_IMPORTED_MODULE_1__router__["c" /* dynamicRouters */], roles);
				}
				commit('GENERATE_DYNAMIC_ROUTERS', allowedRouters);
				resolve();
			}).catch(function (error) {});
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_login__ = __webpack_require__(315);



// here I am using four different functions to fetch user's information
// but there should be only two functions loginByEmail and getUserInfo 
// the reason why I did this is I created four faked apis. 
// In production env, the backend should response correct data based on
// user's login info



var user = {
	state: {
		user: '',
		status: '',
		code: '',
		token: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('My-Token'),
		name: '',
		avatar: '',
		introduction: '',
		roles: []
	},
	mutations: {
		CHANGE_PERM: function CHANGE_PERM(state) {
			state.roles = ['editor'];
		},
		SET_CODE: function SET_CODE(state, code) {
			state.code = code;
		},
		SET_TOKEN: function SET_TOKEN(state, token) {
			state.token = token;
		},
		SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
			state.introduction = introduction;
		},
		SET_SETTING: function SET_SETTING(state, setting) {
			state.setting = setting;
		},
		SET_NAME: function SET_NAME(state, name) {
			state.name = name;
		},
		SET_AVATAR: function SET_AVATAR(state, avatar) {
			state.avatar = avatar;
		},
		SET_ROLES: function SET_ROLES(state, roles) {
			state.roles = roles;
		},
		LOGOUT_USER: function LOGOUT_USER(state) {
			state.user = '', state.status = '', state.code = '', state.token = '', state.name = '', state.avatar = '', state.introduction = '', state.roles = [];
		}
	},
	actions: {
		ChangePermission: function ChangePermission(_ref) {
			var commit = _ref.commit;

			commit('CHANGE_PERM');
		},
		LoginByEmail: function LoginByEmail(_ref2, userInfo) {
			var commit = _ref2.commit;

			var email = userInfo.email.trim();
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (email === 'admin@test.com') {
					console.log('admin logged in');
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* loginByEmailAdmin */])(email, userInfo.passowrd).then(function (response) {
						// comment below due to github issue, can not send http request
						//	const data = response.data;

						//Cookies.set('My-Token',response.data.token);
						//commit('SET_TOKEN',data.token);
						__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('My-Token', 'admin');
						commit('SET_TOKEN', 'admin');
						resolve();
					}).catch(function (error) {
						reject(error);
					});
				}

				if (email === 'editor@test.com') {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["b" /* loginByEmailEditor */])(email, userInfo.passowrd).then(function (response) {
						// comment below due to github issue, can not send http request
						//	const data = response.data;

						//Cookies.set('My-Token',response.data.token);
						//commit('SET_TOKEN',data.token);
						__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('My-Token', 'editor');
						commit('SET_TOKEN', 'editor');
						resolve();
					}).catch(function (error) {
						reject(error);
					});
				}
			});
		},
		GetInfo: function GetInfo(_ref3) {
			var commit = _ref3.commit,
			    state = _ref3.state;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				// should be the below method, 
				// getUserInfo(state.token).then((response) => {
				// 	const data = response.data;
				// 	commit('SET_NAME',data.name);
				// 	commit('SET_AVATAR',data.avatar);
				// 	commit('SET_ROLES', data.roles);
				// 	resolve(data);
				// }).catch((error)=>{
				// 	reject(error);
				// });

				// those two methods are using is because I am using fake api
				if (state.token === 'admin') {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["c" /* getUserInfoAdmin */])(state.token).then(function (response) {
						// comment below due to github issue, can not send http request
						//const data = response.data;

						// commit('SET_NAME',data.name);
						// commit('SET_AVATAR',data.avatar);
						// commit('SET_ROLES', data.roles);
						// resolve(data);
						commit('SET_NAME', 'Yi');
						commit('SET_AVATAR', '');
						commit('SET_ROLES', ['admin']);
						resolve({ name: 'Yi', avatar: '', roles: ['admin'] });
					}).catch(function (error) {
						reject(error);
					});
				}

				if (state.token === 'editor') {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["d" /* getUserInfoEditor */])(state.token).then(function (response) {
						// comment below due to github issue, can not send http request
						//const data = response.data;
						// commit('SET_NAME',data.name);
						// commit('SET_AVATAR',data.avatar);
						// commit('SET_ROLES', data.roles);
						// resolve(data);
						commit('SET_NAME', 'Yi');
						commit('SET_AVATAR', '');
						commit('SET_ROLES', ['editor']);
						resolve({ name: 'Yi', avatar: '', roles: ['editor'] });
					}).catch(function (error) {
						reject(error);
					});
				}
			});
		},
		LogOut: function LogOut(_ref4) {
			var commit = _ref4.commit;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["e" /* logOut */])().then(function (response) {
					commit('LOGOUT_USER');
					__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove('My-Token');
					resolve();
				}).catch(function (error) {
					reject(error);
				});
			});
		}
	}
};
/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(141);





var axiosInstance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  timeout: 5000
});

axiosInstance.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.token) {
    config.headers['MY-TOKEN'] = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.token;
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// Add a response interceptor
axiosInstance.interceptors.response.use(function (response) {
  return response;
  // based on response display the error message
  // const res = response.data;
  // console.log(response.data);
  // const error = {message: ''};
  // if (res.code !== 200) {
  //   error.message = 'something bad happened!'
  //   return Promise.reject(error);
  // } else {
  //   return response.data;
  // }
}, function (error) {
  // Do something with response error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* unused harmony default export */ var _unused_webpack_default_export = (axiosInstance);

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filterDynamicRouters;
function hasPermission(roles, route) {
	if (route.meta && route.meta.role) {
		return roles.some(function (role) {
			route.meta.role.indexOf(role) >= 0;
		});
	}
	return true;
}

function filterDynamicRouters(dynamicRouters, roles) {
	var allowedDynamicRouters = dynamicRouters.filter(function (route) {
		if (hasPermission(roles, route)) {
			if (route.children && route.children.length) {
				route.children = filterDynamicRouters(route.children, roles);
			}
			return true;
		}
		return false;
	});
	return allowedDynamicRouters;
}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(765),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(756),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(758),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(751),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(752),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(768),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf9faa54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(760),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56d9c055",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(754),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23da951a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(753),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(769),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(761),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(767),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(772),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(764),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(766),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce1bfe36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(763),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b25649f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(755),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2aa0c302",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(770),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e3dbd8fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(748),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(762),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 748:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "makrdonw-container"
    }
  }, [_c('textarea', {
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: _vm.height,
      width: _vm.width
    }),
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "components-container"
    }
  }, [(_vm.option) ? _c('ESchart', {
    attrs: {
      "option": _vm.option,
      "id": _vm.id
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "components-container"
    }
  }, [_c('RichtextEditor', {
    attrs: {
      "id": "contentEditor"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  this is permission page for admin\n")])
},staticRenderFns: []}

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.option1) ? _c('ESchart', {
    attrs: {
      "height": "50vh",
      "option": _vm.option1,
      "id": "chart1"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.option2) ? _c('ESchart', {
    attrs: {
      "height": "50vh",
      "option": _vm.option2,
      "id": "chart2"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-container"
    }
  }, [_c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginRules,
      "label-width": "0px",
      "id": "login-form"
    }
  }, [_c('h3', [_vm._v("Login")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "email"
    },
    model: {
      value: (_vm.loginForm.email),
      callback: function($$v) {
        _vm.loginForm.email = $$v
      },
      expression: "loginForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.loginForm.password = $$v
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "id": "login-btn"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleLogin($event)
      }
    }
  }, [_vm._v("Login")])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', [_c('li', [_vm._v("Emails: admin@test.com, editor@test.com")]), _vm._v(" "), _c('li', [_vm._v("admin@test.com could access all pages")]), _vm._v(" "), _c('li', [_vm._v("editor@test.com can see homepage only")]), _vm._v(" "), _c('li', [_vm._v("Password is anything you like but at least 6 digits")])])])
}]}

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "components-container"
    }
  }, [_c('Draggablelist', {
    attrs: {
      "id": "contentEditor",
      "init-list1": _vm.list1,
      "init-list2": _vm.list2,
      "list1-title": "Top 3 customers",
      "list2-title": "Other customers",
      "displayedProperty": "name"
    },
    on: {
      "update:initList1": function($event) {
        _vm.list1 = $event
      },
      "update:initList2": function($event) {
        _vm.list2 = $event
      }
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateChange
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "components-container"
    }
  }, [(_vm.option) ? _c('ESchart', {
    attrs: {
      "option": _vm.option,
      "id": _vm.id
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "components-container"
    }
  }, [_c('MarkdownEditor', {
    attrs: {
      "id": "contentEditor",
      "height": 300,
      "zIndex": 20
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.markdown2Html
    }
  }, [_vm._v("Convert to html")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "theme": "dark",
      "default-active": _vm.$route.path
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.routes
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont_principal"
  }, [_c('div', {
    staticClass: "cont_error"
  }, [_c('h1', [_vm._v("Oops")]), _vm._v(" "), _c('p', [_vm._v("The page you are looking for is not there.")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to home")])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 761:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "fit": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "time"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.editing),
            expression: "!scope.row.editing"
          }],
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.date))]), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.editing),
            expression: "scope.row.editing"
          }],
          attrs: {
            "format": "yyyy-MM-dd",
            "align": "right",
            "type": "date",
            "placeholder": "Select date",
            "picker-options": _vm.pickerOptions1
          },
          model: {
            value: (scope.row.date),
            callback: function($$v) {
              scope.row.date = $$v
            },
            expression: "scope.row.date"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.editing),
            expression: "!scope.row.editing"
          }]
        }, [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), _c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.editing),
            expression: "scope.row.editing"
          }],
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              scope.row.name = $$v
            },
            expression: "scope.row.name"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.editing),
            expression: "!scope.row.editing"
          }]
        }, [_vm._v(_vm._s(scope.row.address))]), _vm._v(" "), _c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.editing),
            expression: "scope.row.editing"
          }],
          model: {
            value: (scope.row.address),
            callback: function($$v) {
              scope.row.address = $$v
            },
            expression: "scope.row.address"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Options"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.editing),
            expression: "scope.row.editing"
          }],
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.handleSave(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.editing),
            expression: "scope.row.editing"
          }],
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleCancelEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Cancel Edit")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.editing),
            expression: "!scope.row.editing"
          }],
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.editing),
            expression: "!scope.row.editing"
          }],
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "richtext-container"
    }
  }, [_c('textarea', {
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path === '/' ? item.path + item.children[0].path : item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path === '/' ? item.path + item.children[0].path : item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _c('span', {
      staticClass: "sidebar-item-name"
    }, [_vm._v(_vm._s(item.children[0].name))])])], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown &&
      !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _c('span', {
      staticClass: "sidebar-item-name"
    }, [_vm._v(_vm._s(item.name) + "  ")])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(!child.children) ? _c('router-link', {
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(child.name) + "\n\t\t\t\t\t")])], 1) : _vm._e()] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData3,
      "border": "",
      "fit": "",
      "width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Post info"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Address"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "State",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "City",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zip",
      "label": "Post",
      "width": "120"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "components-container"
    }
  }, [(_vm.option) ? _c('ESchart', {
    attrs: {
      "option": _vm.option,
      "id": _vm.id
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4,
      "id": "sidebar-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('Sidebar')], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20,
      "id": "content-container"
    }
  }, [_c('Navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Activity name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Activity area"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please select activity area"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.form.region = $$v
      },
      expression: "form.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Melbourne",
      "value": "Melbourne"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Sydney",
      "value": "Sydney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Activity time"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Please select date"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.form.date1 = $$v
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "fixed-time",
      "placeholder": "Please select time"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.form.date2 = $$v
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Delivery"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.form.delivery = $$v
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Activity"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.form.type = $$v
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "online",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "offline",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Resources"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.resource),
      callback: function($$v) {
        _vm.form.resource = $$v
      },
      expression: "form.resource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Free gift"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "Free food"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Activity description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.form.desc = $$v
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont_principal"
  }, [_c('div', {
    staticClass: "cont_error"
  }, [_c('h1', [_vm._v("Oops")]), _vm._v(" "), _c('p', [_vm._v("You don't have the permission to visit this page.")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to home")])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("Add Company")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Company",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.company
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.company.name = $$v
      },
      expression: "company.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please select state"
    },
    model: {
      value: (_vm.company.state),
      callback: function($$v) {
        _vm.company.state = $$v
      },
      expression: "company.state"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "VIC",
      "value": "VIC"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "NSW",
      "value": "NSW"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.city),
      callback: function($$v) {
        _vm.company.city = $$v
      },
      expression: "company.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.address),
      callback: function($$v) {
        _vm.company.address = $$v
      },
      expression: "company.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Post"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.company.post),
      callback: function($$v) {
        _vm.company.post = $$v
      },
      expression: "company.post"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handelCreateCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handelCreateConfrim
    }
  }, [_vm._v("Create")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData3,
      "border": "",
      "fit": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "State"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "City"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post",
      "label": "Post"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.list1Title))])]), _vm._v(" "), _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": _vm.dragOptions
    },
    on: {
      "end": _vm.updateList
    },
    model: {
      value: (_vm.list1),
      callback: function($$v) {
        _vm.list1 = $$v
      },
      expression: "list1"
    }
  }, _vm._l((_vm.list1), function(element) {
    return _c('div', {
      key: element.name,
      staticClass: "list-item"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(element[_vm.displayedProperty]) + "\n          ")])
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.list2Title))])]), _vm._v(" "), _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": _vm.dragOptions
    },
    on: {
      "end": _vm.updateList
    },
    model: {
      value: (_vm.list2),
      callback: function($$v) {
        _vm.list2 = $$v
      },
      expression: "list2"
    }
  }, _vm._l((_vm.list2), function(element) {
    return _c('div', {
      key: element.name,
      staticClass: "list-item"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(element[_vm.displayedProperty]) + "\n          ")])
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "theme": "light",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_vm._v("Logout")])], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v("Manage delivery")]), _vm._v(" "), _c('keep-alive', [(_vm.activeName === 'first') ? _c('Tablecontent') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v("Create activity")]), _vm._v(" "), _c('keep-alive', [(_vm.activeName === 'second') ? _c('Formcontent') : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(750),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepClone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

function deepClone(source) {
  if (!source && (typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) !== 'object') {
    throw new Error('error arguments', 'shallowClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  for (var keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source[keys]) === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

/***/ })

},[316]);


// WEBPACK FOOTER //
// static/js/app.0547de604c5f83ae8720.js